import { captureEvent } from "@/shared/analytics/analytics";

export type ActivationMilestone = "team" | "kudos" | "check_in" | "complete";

function storageKey(userId: string, workspaceId: string, milestone: ActivationMilestone): string {
  return `pw-activation:v1:${userId}:${workspaceId}:${milestone}`;
}

/** Emits each onboarding milestone once per user and workspace in this browser. */
export function captureActivationOnce(
  userId: string,
  workspaceId: string,
  milestone: ActivationMilestone,
): void {
  const key = storageKey(userId, workspaceId, milestone);
  try {
    if (localStorage.getItem(key) === "1") return;
    localStorage.setItem(key, "1");
  } catch {
    // Storage failure can cause a duplicate later, but must not block capture.
  }

  if (milestone === "team") {
    captureEvent("activation_team_added", { method: "import" });
  } else if (milestone === "kudos") {
    captureEvent("activation_kudos_created");
  } else if (milestone === "check_in") {
    captureEvent("activation_check_in_completed");
  } else {
    captureEvent("activation_completed");
  }
}
